// =============================================================================
// AGENT 2 — MISTRZ UI: KAFELEK ZGŁOSZENIA
// Drag source — wywoływany przez GameBoard.
// =============================================================================

import './TaskCard.css';
import type { Task } from '../../types/models';

interface TaskCardProps {
  task: Task;
  isDragging?: boolean;
  onDragStart: (taskId: string) => void;
  onDragEnd: () => void;
  /** Wywołane przez Touch API po podniesieniu na urządzeniu dotykowym */
  onTouchStart: (e: React.TouchEvent, taskId: string) => void;
  onTouchMove: (e: React.TouchEvent) => void;
  onTouchEnd: (e: React.TouchEvent) => void;
  onTouchCancel: () => void;
}

const PRIORITY_LABELS: Record<Task['priority'], string> = {
  awaria: 'Awaria',
  pilne: 'Pilne',
  normalne: 'Normalne',
  rutynowe: 'Rutynowe',
};

export function TaskCard({
  task,
  isDragging,
  onDragStart,
  onDragEnd,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onTouchCancel,
}: TaskCardProps) {
  return (
    <div
      className={`task-card${isDragging ? ' task-card--dragging' : ''}`}
      data-priority={task.priority}
      data-task-id={task.id}
      draggable
      onDragStart={() => onDragStart(task.id)}
      onDragEnd={onDragEnd}
      onTouchStart={(e) => onTouchStart(e, task.id)}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchCancel}
      aria-label={`Zgłoszenie: ${task.title}, priorytet: ${PRIORITY_LABELS[task.priority]}`}
    >
      <div className="task-card__priority-pill" aria-hidden>
        {PRIORITY_LABELS[task.priority]}
      </div>

      <div className="task-card__title-wrap">
        <div className="task-card__title">{task.title}</div>
      </div>

      <div className="task-card__icon-shell" aria-hidden>
        <img
          className="task-card__icon"
          src={task.iconAsset}
          alt=""
          onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
        />
      </div>
    </div>
  );
}
